<script setup lang="ts">
import { Locales } from '@/store/language.interface';
import { getTranslation } from '@/utils/data-display-utils';

// PROPS
const props = defineProps<{
  choice: any;
  languageEnabled?: Locales[];
}>();
</script>

<template>
  <q-btn flat no-caps align="around" class="base-image-button">
    <div class="image">
      <img :src="props.choice.image?.url" alt="" role="presentation" />
    </div>
    <div class="text">
      {{ getTranslation(choice, 'text', props.languageEnabled) }}
    </div>
  </q-btn>
</template>

<style lang="scss">
.q-btn.base-image-button {
  justify-content: space-between;
  padding: $space-xs;
  border: 2px solid $color-neutral-grey-300;
  border-radius: 8px;
  background-color: $color-neutral-white;
  color: $color-primary-darken;

  &:hover {
    background-color: $color-neutral-grey-100;
    font-weight: bold;
  }

  &:active {
    border: 1px solid $color-primary;
  }

  div {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-wrap: anywhere;
  }

  .text {
    padding-right: $space-sm;
  }

  .image {
    margin: 0 5px;

    img {
      border-radius: 8px;
      margin: 10px;
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 200px;
      object-fit: contain;
    }
  }
}

@media screen and (max-width: $breakpoint-sm) {
  .q-btn.base-image-button {
    img {
      border-radius: 8px;
      max-height: 90%;
      max-width: 90%;
    }

    .image {
      width: 40%;
      display: flex;
      align-content: center;
      justify-content: center;
    }

    .text {
      display: flex;
      justify-content: center;
      padding: 0 $space-xs;
      width: 60%;
    }
  }
}
</style>
